export function setupOnlineServer({ onlineServiceStatus, onlineServiceCode, onlineServicePosition }) {
  // 设置在线服务开始
  if (onlineServiceStatus === 'true' && onlineServiceCode) {
    const div = document.createElement('div')
    div.innerHTML = onlineServiceCode
    const list = div.childNodes
    list.forEach((el) => {
      // if (el.tagName === 'SCRIPT') {
      //   if (onlineServicePosition === '1') {
      //     document.body.appendChild(el)
      //   } else {
      //     document.head.appendChild(el)
      //   }
      // }
      append(el, onlineServicePosition)
    })
  }
  // 设置在线服务结束
}

export function append(el, onlineServicePosition) {
  if (el.src) {
    const code = document.createElement('script')
    for (let i = 0; i < el.attributes.length; i++) {
      if (el.attributes[i].specified) {
        code[el.attributes[i].nodeName] = el.attributes[i].nodeValue || 'index'
      }
    }
    document.body.appendChild(code)
  } else if (el.tagName === 'SCRIPT') {
    const code = document.createElement('script')
    if (!el.innerHTML) return

    // Check if the script content contains module syntax
    if (el.innerHTML.includes('export ') || el.innerHTML.includes('import ')) {
      code.type = 'module' // Set type="module" for ES module scripts
    }

    code.innerHTML = el.innerHTML
    if (onlineServicePosition === '1') {
      document.body.appendChild(code)
    } else {
      document.head.appendChild(code)
    }
  }
}
